<template>
    <b-container fluid>
        <Loading :active.sync="Loading"></Loading>
        <h2>Preprensa</h2>
        <List :items="ordenes" :fields="fields" :urls="urls" :comentarios="comentarios" />
    </b-container>   
</template>

<script>
    //importacion de terceros
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import {mapActions, mapState, mapGetters} from 'vuex'
    //importacion local
    import List from '@/components/preprensa/List'

    export default {
        name:'listadoPreprensa',
        components:{
            Loading, List 
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState(['Loading']),
            ...mapState('preprensa',['ordenes']),
            ...mapState('urls',['urls']),
            ...mapState('comentarioIng',['comentarios'])
        },
        data:function () {
            return{
                fields:[
                    {key: 'orden',label:'Prioridad',sortable:true},
                    {key: 'id',label:'Folio',sortable:true},
                    {key: 'cliente', label:'Cliente',sortable:true},
                    {key:'acciones', label:'Acciones'},
                    {key:'producto', lable:'Producto',sortable:true},
                    {key:'cantidad', label:'Cantidad'},
                    {key:'trabajo', label:'Trabajo', sortable:true},
                    {key:'otro', label:'otro'},
                    {key:'fecha', label:'Fecha', sortable:true},
                    {key:'hora', label:'Hora'},
                    {key:'solicitante', label:'Solicitante', sortable:true},
                    {key:'url', label:'Link de archivo'},
                    {key:'observaciones',label:'Observaciones'},
                    {key:'comentario_ingenieria', label:'Observaciones Ingenieria'},
                    {key:'status',label:'Estado', sortable:true, variant: 'primary'},
                    {key:'preprensa',label:'Comentario de preprensa'},
                    {key:'ingenieria',label:'Comentario de ingenieria'},
                    {key:'create_at',label:'Creación'},
                    {key:'update_at',label:'Ultima Actualización'},
                    
                    ]
            }            
        },
        methods:{
            ...mapActions({
                _fetchOrdenes: 'preprensa/fetchOrdenes',
                _fetchUrls: 'urls/fetchUrls',
                _comentarios: 'comentarioIng/fetchComentarios'
            }),
            init(){
                this._fetchOrdenes()
                this._fetchUrls()
                this._comentarios()
            }
        }
        
    }
</script>

<style lang="scss" scoped>

</style>